import { render, staticRenderFns } from "./MSTeamsPresentationTable.vue?vue&type=template&id=8e5fc152"
import script from "./MSTeamsPresentationTable.vue?vue&type=script&lang=js"
export * from "./MSTeamsPresentationTable.vue?vue&type=script&lang=js"
import style0 from "./MSTeamsPresentationTable.vue?vue&type=style&index=0&id=8e5fc152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports